/* eslint-disable react/no-array-index-key */
import { Box, Grid } from '@mantine/core';

import { EditContextProvider } from '../context/EditContext';

import Title from '@/components/content/title/Title';
import ModuleWrapper from './ModuleWrapper';
import Submodule from './Submodule';

import type { SubmoduleDef } from '../types/modulesv2';

import classes from './IssueModule.module.css';

interface IssueGridProps<TData> {
  title?: string;
  submodules: Array<SubmoduleDef<TData>>;
  noPrint?: boolean;
  variant?: string;
}

const IssueGrid = <TData extends unknown>({
  title,
  submodules,
  noPrint,
  variant,
}: IssueGridProps<TData>) => (
  <div className={`${noPrint ? 'noPrint' : ''}`}>
    <Box mt={25}>
      {variant === 'sidebar' ? (
        <h2 className={classes.sidebarHeading}>{title}</h2>
      ) : (
        <Title order={2}>{title}</Title>
      )}
    </Box>

    <Grid columns={6} classNames={{ root: classes.grid }} grow>
      {submodules.map((submodule, i) => (
        <Grid.Col
          key={`grid-submodule-${i}-${title}`}
          span={variant === 'sidebar' ? 6 : { base: 6, xs: 3, md: 6, xl: 3 }}
        >
          <ModuleWrapper expand variant={variant}>
            <EditContextProvider>
              <Submodule submodule={submodule} />
            </EditContextProvider>
          </ModuleWrapper>
        </Grid.Col>
      ))}
    </Grid>
  </div>
);

export default IssueGrid;
